import * as React from "react"
import { Box } from "@mui/material"
import { AXIOS_API_INSTANCE } from "../../Constants"
import { send_authorized_request } from "../../Constants/cognito"
import { LoadingBackdropIndeterminate } from "../LoadingBackdrop"
import { DataGrid, GridToolbar } from "@mui/x-data-grid"
import { useSnackbar } from "notistack"
import { useServiceOrderItemTypes } from "../ReactQuery/QueryServiceOrderItemTypes"

const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
}).format

export default function ServiceOrderItemTypesReport({ startDatetime, endDatetime, selectedLocations }) {
    const { enqueueSnackbar } = useSnackbar();
    const { data: serviceOrderItemTypes } = useServiceOrderItemTypes();
    const [isLoading, setIsLoading] = React.useState(false)
    const [data, setData] = React.useState([])

    const getData = (start_datetime, end_datetime, location_ids) => {
        if (!location_ids || location_ids.length === 0) {
            return
        }
        setIsLoading(true)
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.get("reports/serviceorderitemtypes", {
                params: {
                    start_datetime: start_datetime,
                    end_datetime: end_datetime.add(1, 'day'),
                    location_ids: location_ids
                },
            }).then((data) => {
                setData(data.data.data)
                setIsLoading(false)
            }).catch((error) => {
                console.log(error)
                setIsLoading(false)
                enqueueSnackbar(`Failed to load data <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
            })
        )
    }

    React.useEffect(() => {
        getData(startDatetime, endDatetime, selectedLocations.map((x) => x.id))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startDatetime, endDatetime, selectedLocations])

    const table_data = serviceOrderItemTypes.map((type) => {
        const row = { id: type.id, name: type.name, count: 0, total: 0 }
        Object.keys(data).forEach((location_id) => {
            const loc = selectedLocations.find((loc) => loc.id.toString() === location_id)
            const my_data = data[location_id][type.id] ?? {}
            row[`${loc.id}-count`] = my_data.count ?? 0
            row[`${loc.id}-total`] = my_data.sum_total_cost ?? 0
            row.count += my_data.count ?? 0
            row.total += my_data.sum_total_cost ?? 0
        })
        return row
    })

    const totals_columns = selectedLocations.length > 1 ? [{
        field: "count",
        headerName: "Total Count",
        flex: 1,
        editable: false,
        sortable: true,
        valueFormatter: (value) => value > 0 ? value : '-'
    },
    {
        field: "total",
        headerName: "Total Amount",
        flex: 1,
        editable: false,
        sortable: true,
        valueFormatter: (value) => currencyFormatter(value)
    }] : []

    const location_columns = selectedLocations.map((loc) => {
        return [{
            field: `${loc.id}-count`,
            headerName: `${loc.name} Count`,
            flex: 1,
            editable: false,
            sortable: true,
            valueFormatter: (value) => value > 0 ? value : '-'
        },
        {
            field: `${loc.id}-total`,
            headerName: `${loc.name} Total`,
            flex: 1,
            editable: false,
            sortable: true,
            valueFormatter: (value) => currencyFormatter(value)
        }]
    }).flat()

    console.log(table_data)


    return (
        <React.Fragment>
            <Box>
                <LoadingBackdropIndeterminate
                    open={isLoading}
                    text="Loading Report"
                />
                {!isLoading &&
                    <Box>
                        <p>Service Orders created and total invoiced for each Service Order Item Type. NOTE: Only includes invoices which have been finalized</p>
                        <DataGrid
                            rows={table_data}
                            slots={{ toolbar: GridToolbar }}
                            initialState={{
                                sorting: {
                                    sortModel: [{ field: selectedLocations.length > 1 ? 'count' : `${selectedLocations[0]?.id}-count`, sort: 'desc' }],
                                },
                            }}
                            columns={[
                                {
                                    field: "name",
                                    headerName: "Item Type",
                                    flex: 2,
                                    editable: false,
                                    sortable: true,
                                },
                                ...totals_columns,
                                ...location_columns
                            ]}
                            disableRowSelectionOnClick
                        />
                    </Box>
                }
            </Box>
        </React.Fragment>
    )
}